<div class="rec-toolbar">

  <div class="rt-row rt-row--step" *ngIf="steps.selectedStep">
    <button class="btn-back" (click)="back()" title="Back to Steps">
      <span class="material-symbols-outlined">arrow_back</span>
    </button>
    <span class="toolbar-title">{{ steps.selectedStep.name }}</span>

    <div class="tb-icons">
      <button class="tb-icon" (click)="onRenameStep()" title="Rename step">
        <span class="material-symbols-outlined">edit</span>
      </button>
      <button class="tb-icon" (click)="onDeleteStep()" title="Delete step">
        <span class="material-symbols-outlined">delete</span>
      </button>
      <button class="tb-icon" (click)="onCopyStep()" title="Copy step">
        <span class="material-symbols-outlined">content_copy</span>
      </button>
    </div>
  </div>

  <div class="rt-row rt-row--list-header" *ngIf="!steps.selectedStep">
    <span class="toolbar-title toolbar-title--section">STEPS</span>

    <div class="row-menu">
      <button class="row-menu-trigger" (click)="toggleOptionsMenu($event)" title="Step options">
        <span class="material-symbols-outlined">tune</span>
      </button>
      <div class="row-menu-dropdown panel-checks" *ngIf="optionsMenuOpen" (click)="$event.stopPropagation()">
        <label class="tb-check">
          <input type="checkbox" [checked]="removeDuplicatesApplied" (change)="onToggleRemoveDuplicates()" />
          Remove Duplicate Clicks
        </label>
        <label class="tb-check">
          <input type="checkbox" [(ngModel)]="stepSave.saveStepsChecked" />
          Save Steps
        </label>
        <label class="tb-check">
          <input type="checkbox" [(ngModel)]="parameterizeStepsChecked" />
          Parameterize Steps
        </label>
      </div>
    </div>
  </div>

  <div class="rt-row rt-actions">
    <button class="sim-btn" (click)="addStep()">
      <span class="material-symbols-outlined">add</span> New Step
    </button>

    <button
      class="sim-btn sim-btn--record"
      [class.sim-btn--recording]="recorderSession.isRecording"
      [disabled]="!recorderSession.sessionId || recordingPending || (!steps.selectedStep && !recorderSession.isRecording)"
      [title]="!steps.selectedStep && !recorderSession.isRecording ? 'Select or create a step to record into' : ''"
      (click)="toggleRecording()">
      <span *ngIf="recordingPending" class="spinner-sm"></span>
      <span *ngIf="!recordingPending" class="material-symbols-outlined">{{ recorderSession.isRecording ? 'stop_circle' : 'fiber_manual_record' }}</span>
      {{ recordingPending ? (recorderSession.isRecording ? 'Stopping…' : 'Starting…') : (recorderSession.isRecording ? 'Stop' : 'Record') }}
    </button>
  </div>

  <div class="rt-row" *ngIf="steps.selectedStep">
    <button class="sim-btn sim-btn--full" [disabled]="saveState === 'saving'" (click)="onSaveToCanvas()">
      <span class="material-symbols-outlined">{{ saveState === 'saving' ? 'hourglass_empty' : 'save' }}</span>
      Save to Canvas
    </button>
  </div>

</div>

<div class="toast-container">
  <div class="toast toast--success" *ngIf="toastMessage && toastType === 'success'">{{ toastMessage }}</div>
  <div class="toast toast--error" *ngIf="toastMessage && toastType === 'error'">{{ toastMessage }}</div>
</div>
